import React, { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'
import './styles/createproblem.css'
import { navRef } from './refs';

import { ENDPOINT, ENDPOINTGO, makeDraggable, MINLENGHTPROBLEM, NetworkCall, ShowNotification } from '../utils/constants'
import SyntaxHighlighter from 'react-syntax-highlighter';
import Axios from 'axios';
import Cookie from 'js-cookie'

export default function CreateProblem() {

    const [markdown, setMarkDown] = useState('')
    const [markDownBase64, setMarkDownBase64] = useState('')
    const [problemId, setProblemId] = useState(null)
    const handleChange = (e) => {
        setMarkDown(e.target.value)
    }
    const handleFullScreen = () => {
        try {
            navRef.current.style.display = navRef.current.style.display === 'none' ? 'flex' : 'none'
            let elem = document.getElementsByTagName('body')[0]
            if (navRef.current.style.display == 'flex') {
                // document.exitFullscreen()
            }
            else if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }
        } catch (e) { }

    }

    useEffect(() => {
        // makeDraggable('crpr-details-wrapper-input-box')
    }, [])

    const editorRef = useRef(null)

    const handleEditorNextValid = () => {
        if (lockNetworkCall) return

        if (markdown.length < MINLENGHTPROBLEM) {
            ShowNotification("Don't you think the problem body is too short?", "red", 4000)
            return
        }
        const blob = new Blob([markdown], { type: "text/plain;charset=utf-8" })
        let reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = () => {
            const _markDownBase64 = reader.result
            setMarkDownBase64(reader.result)
            const dataToSubmit = {
                title: problemTitle, difficulty: difficulty, tutorialYoutubeLink: tutorialLink, points: points, category: category,
                problemBodyBase64: _markDownBase64
            }
            ShowNotification('Creating problem...', 'blue', -1)
            lockNetworkCall = true
            Axios.post(ENDPOINT + "/problems/create/problemstatement", dataToSubmit)
                .then(res => {
                    setProblemId(res.data.problem._id)
                    ShowNotification("Success!", 'green', 2000)
                    lockNetworkCall = false
                    setCurrentView('fileupload')
                    // Cookie.set("problemId", problemId, {expires:100})   //saving it to the cookie in case if the browser refreshed 
                })
                .catch(err => {
                    ShowNotification("Something went wrong", "red", -1)
                    lockNetworkCall = false
                })
        }
    }


    const Editor = () => (
        <>
            <div className="crpr-toolbar">
                <div><i className="fa fa-arrows-alt" aria-hidden="true" id="sol-left-chevoron" onClick={handleFullScreen}></i></div>
                <div className="crpr-details-next" onClick={() => { setCurrentView("details") }} style={{ marginTop: 0, marginLeft: '2rem', marginRight: '1rem' }}>Prev</div>
                {
                    markdown.length == 0 && <div onClick={handleEditorNextValid} className="crpr-details-next disabled" style={{ marginTop: 0, marginLeft: '2rem', marginRight: '1rem' }}>Next</div>
                }
                {
                    markdown.length != 0 && <div className="crpr-details-next" onClick={handleEditorNextValid} style={{ marginTop: 0, marginLeft: '2rem', marginRight: '1rem' }}>Next</div>
                }
            </div>
            <div className="crpr-left-right-wrapper">
                <div className="crpr-left">
                    <textarea ref={editorRef} className='boxsizingBorder' onChange={(e) => { handleChange(e) }} autoFocus="autofocus" value={markdown} placeholder="Write the problem statement here in markdown"></textarea>
                </div>
                <div className="crpr-right">
                    <ReactMarkdown plugins={[gfm]} children={markdown} />
                </div>
            </div>
        </>
    )
    const [problemTitle, setProblemTitle] = useState('')
    const [difficulty, setDificulty] = useState('Difficulty')
    const [category, setCategory] = useState('Category')
    const [points, setPoints] = useState('Points')
    const [currentView, setCurrentView] = useState('details')
    const [tutorialLink, setTutorialLink] = useState('')

    const handleDifficultyClick = (e) => {
        setDificulty(e.target.textContent)
    }

    const handleCategoryClick = (e) => {
        setCategory(e.target.textContent)
    }

    const handlePointsClick = (e) => {
        setPoints(Number(e.target.textContent))
    }
    const handleOnChangeTurialLink = (e) => {
        setTutorialLink(e.target.value)
    }

    const handleChangeProblemTitle = (e) => {
        if (problemTitle.length > 100) {
            ShowNotification('Problem title too long!', 'red', 3000)
            return
        }
        setProblemTitle(e.target.value)
    }
    const handleInValidNextClick = () => {
        if (problemTitle.length <= 2) {
            ShowNotification("Problem title too short", 'red', 2000)
            return
        }
        if (difficulty == 'Difficulty') {
            ShowNotification("Please select a difficulty level", 'red', 2000)
            return
        }
        if (category == 'Category') {
            ShowNotification("Please select a category", 'red', 2000)
            return
        }
        if (points == 'Points') {
            ShowNotification("Please select a point", 'red', 2000)
            return
        }
        if (tutorialLink.length != 0) {
            let pattern = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/i
            let match = tutorialLink.match(pattern)
            if (!match) {
                ShowNotification('Please provide a valid youtube link', 'red', 3000)
                return
            }
        }
    }
    //for title
    const handleNextValid = () => {
        let charCount = 0
        for (let i = 0; i < problemTitle.length && charCount < 2; i++) {
            if (problemTitle[i] != ' ')
                charCount++
        }
        if (charCount < 2) {
            ShowNotification("Problem title too short", 'red', 2000)
            return
        }
        if (tutorialLink.length != 0) {
            let pattern = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/i
            let match = tutorialLink.match(pattern)
            if (!match) {
                ShowNotification('Please provide a valid youtube link', 'red', 3000)
                return
            }
        }
        setCurrentView('editor')
        ShowNotification("Write your problem body here", 'green', 4000)
    }

    const Details = () => (
        <div className="crpr-details-wrapper" >
            <div className="crpr-details-wrapper-input-box" id="crpr-details-wrapper-input-box">

                <input type="text" placeholder="Problem title" onChange={handleChangeProblemTitle} value={problemTitle} autoFocus={true} />
                <input type="text" placeholder="Tutorial video link(Youtube) (optional)" onChange={handleOnChangeTurialLink} value={tutorialLink} />

                <div className="crpr-details-wrapper-input-box-dropdownsbox">
                    <div className="dropdown">
                        <button className={"dropbtn crpr-" + difficulty}>{difficulty}</button>
                        <div className="dropdown-content">
                            <span onClick={handleDifficultyClick}>easy</span>
                            <span onClick={handleDifficultyClick}>medium</span>
                            <span onClick={handleDifficultyClick}>hard</span>
                        </div>
                    </div>
                    <div className="dropdown">
                        <button className="dropbtn">{category}</button>
                        <div className="dropdown-content">
                            <span onClick={handleCategoryClick}>array</span>
                            <span onClick={handleCategoryClick}>linkedlist</span>
                            <span onClick={handleCategoryClick}>tree</span>
                            <span onClick={handleCategoryClick}>dynamic programming</span>
                            <span onClick={handleCategoryClick}>backtracking</span>
                            <span onClick={handleCategoryClick}>others</span>
                        </div>
                    </div>
                    <div className="dropdown">
                        <button className={"dropbtn"} style={{ borderRadius: '1rem' }}>{points}</button>
                        <div className="dropdown-content">
                            <span onClick={handlePointsClick}>10</span>
                            <span onClick={handlePointsClick}>15</span>
                            <span onClick={handlePointsClick}>20</span>
                            <span onClick={handlePointsClick}>25</span>
                            <span onClick={handlePointsClick}>30</span>
                            <span onClick={handlePointsClick}>35</span>
                            <span onClick={handlePointsClick}>40</span>
                        </div>
                    </div>
                </div>
                {
                    problemTitle.length > 2 && category != 'Category' && difficulty != 'Difficulty' && points != 'Points' ? <div className="crpr-details-next" onClick={handleNextValid}>Next</div> : <div className="crpr-details-next disabled" onClick={handleInValidNextClick}>Next</div>
                }
            </div>
        </div>
    )


    const [codeTemplateFile, setCodeTemplateFile] = useState(null)
    const [testcaseCodeFile, setTestCaseCodeFile] = useState(null)
    const [solutionCodeFile, setSolutionCodeFIle] = useState(null)
    // const [outputsFile, setOutputsFile] = useState(null)
    const [codeTemplateContent, setCodeTemplateContent] = useState('')
    const [testcaseCodeContent, setTestCaseCodeContent] = useState('')
    const [solutionCodeContent, setSolutionContent] = useState('')



    const onChangeCodetemplateFile = (e) => {
        var files = e.target.files
        var file = files[0]
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => { setCodeTemplateContent(reader.result) }
        setCodeTemplateFile(file)
    }



    const onChangeTestcaseCodeFile = (e) => {
        var files = e.target.files
        var file = files[0]

        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => { setTestCaseCodeContent(reader.result) }

        setTestCaseCodeFile(file)
    }
    const onChangeSolutionCodeFile = (e) => {
        var files = e.target.files
        var file = files[0]

        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => { setSolutionContent(reader.result) }
        setSolutionCodeFIle(file)
    }

    let lockNetworkCall = false

    const handleFinalSubmit = () => {

        if (lockNetworkCall) return

        if (!codeTemplateFile || !testcaseCodeFile || !solutionCodeFile) {
            ShowNotification("Please select all the files", 'red', 3000)
            return
        }
        if (codeTemplateContent.length == 0 || testcaseCodeContent.length == 0 || solutionCodeContent.length == 0) {
            ShowNotification("Files seems to be empty!", 'red', 3000)
            return
        }
        ShowNotification("Uploading", 'green', -1)

        // const dataToSend = {
        //     title: problemTitle, difficulty: difficulty, tutorialYoutubeLink: tutorialLink, points: points, category: category,
        //     problemBodyBase64: markDownBase64, codeTemplateFileContentBase64: codeTemplateContent, testcaseFileContentBase64: testcaseCodeContent
        // }
        const dataToSend = {
            problemId: problemId, codeTemplateFileContentBase64: codeTemplateContent,
            testcaseFileContentBase64: testcaseCodeContent, languageName: currentLanguage.name,
            solutionFileContentBase64: solutionCodeContent
        }
        lockNetworkCall = true
        Axios.post(ENDPOINT + "/problems/create/language", dataToSend)
            .then(res => {
                ShowNotification("Success!!", 'green', 4000)
                // setCurrentView('details')
                lockNetworkCall = false
                let temp = { ...fileTypes }
                temp[currentLanguage.name].isUploaded = true
                setFileTypes(temp)
                cleanUp()
                //setting the selected languge to something other than the uploaded files so far
                let remain = false
                for (const [key, value] of Object.entries(temp)) {
                    if (!value.isUploaded) {
                        setCurrentLanguage(value)
                        remain = true
                        break
                    }
                }
                //if all the languages has been added 
                if (!remain) {
                    ShowNotification("You are all done!", 'green', 5000)
                    setCurrentView('details')
                }

            })
            .catch(err => {
                ShowNotification('Something went wrong :(', 'red', 5000)
                lockNetworkCall = false
            })
    }
    const [fileTypes, setFileTypes] = useState({
        python: { extention: ".py", isUploaded: false, name: "python" },
        javascript: { extention: ".js", isUploaded: false, name: "javascript" },
        "c++": { extention: ".cpp", isUploaded: false, name: "cpp" },
        "c": { extention: ".c", isUploaded: false, name: "c" }
    })
    const [currentLanguage, setCurrentLanguage] = useState(fileTypes.python)

    const cleanUp = () => {
        setCodeTemplateContent('')
        setCodeTemplateFile(null)
        setSolutionCodeFIle(null)
        setSolutionContent('')
        setTestCaseCodeFile(null)
        setTestCaseCodeContent('')
    }

    const handleLanguageSelect = (e) => {
        if (fileTypes[e.target.textContent].isUploaded) {
            ShowNotification("Already uploaded", "yellow", 2000)
            return
        }
        setCurrentLanguage(fileTypes[e.target.textContent])
        cleanUp()
    }

    const FileUploader = () => (
        <>
            <div className="crpr-toolbar">
                <div><i className="fa fa-arrows-alt" aria-hidden="true" id="sol-left-chevoron" onClick={handleFullScreen}></i></div>
                {/* <div className="crpr-details-next" onClick={() => { setCurrentView("editor") }} style={{ marginTop: 0, marginLeft: '2rem', marginRight: '1rem' }}>Prev</div> */}
                <div className="crpr-details-next" onClick={() => { handleFinalSubmit() }} style={{ marginTop: 0, marginLeft: '2rem', marginRight: '1rem' }}>Done</div>
            </div>
            <div className="crpr-fileupload-box">
                <span>Language: </span>
                <div className="dropdown">
                    <button className={"dropbtn"} style={{ borderRadius: '1rem' }}>{currentLanguage.name}</button>
                    <div className="dropdown-content">
                        <span onClick={handleLanguageSelect} >python</span>
                        <span onClick={handleLanguageSelect} >javascript</span>
                        <span onClick={handleLanguageSelect} >c++</span>
                        <span onClick={handleLanguageSelect} >c</span>
                    </div>
                </div>
                <div className="crpr-fileupload-box-each">
                    <span>Upload the Code template <strong>({currentLanguage.extention})</strong></span>
                    <input type="file" accept={currentLanguage.extention} className="crpr-fileupload-box-each-upload" onChange={onChangeCodetemplateFile} />
                </div>
                <div className="crpr-fileupload-box-each">
                    <span>Testcase code <strong>({currentLanguage.extention})</strong></span>
                    <input type="file" accept={currentLanguage.extention} className="crpr-fileupload-box-each-upload" onChange={onChangeTestcaseCodeFile} />
                </div>
                <div className="crpr-fileupload-box-each">
                    <span>Solution code <strong>({currentLanguage.extention})</strong></span>
                    <input type="file" accept={currentLanguage.extention} className="crpr-fileupload-box-each-upload" onChange={onChangeSolutionCodeFile} />
                </div>
            </div>
            <br></br>
            <br></br>
            <div>
                <ol>
                    <span><strong>Instructions</strong></span>
                    <li>The code template file should only contain the neccessary code and should not reveal the hidden testcases. It must only contain a sample input and assertion of the output to run the file directly.</li>
                    <li>The testcase template will be appended to the code template file at submission time. It must be an python unit test file showing passed and failed testcase to stdout</li>
                </ol>
            </div>
        </>
    )

    return (
        <div className="crpr-wrapper">
            <div data-aos="zoom-in">
                {
                    currentView == 'details' && Details()
                }
                {
                    currentView == 'editor' && Editor()
                }
                {
                    currentView == 'fileupload' && FileUploader()
                }
            </div>

        </div>
    )
}